import firebase from "@/firebase/init";

import "firebase/firestore";
export default firebase.firestore();
